module.exports = __webpack_public_path__ + "img/blurcamera.d2d68327.jpg";